export default class WideGridInitConfig {
  constructor ({ defaultParameters, metricOptions, defaultMetric }) {
    this.defaultParameters = defaultParameters
    this.metricOptions = metricOptions
    this.defaultMetric = defaultMetric
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/WideGridInitConfig.js